import { replacePort } from '../../Profiles/Util/replacePort';
import { createDevelopmentPortsConfig } from './createDevelopmentPortsConfig';
/**
 * Returns an overridden local `developmentPath` for any ALIB package matching or included in the
 * `DEVELOPMENT_PACKAGE` environment variable.
 *
 * The package will then be fetched from the provided host, rather than from the ALIB CDN.
 */
var setLocalDevelopmentPath = function (packageName, portsConfig, coreHarnessPath) {
    if (portsConfig === void 0) { portsConfig = ingestOrSetPortsConfig(); }
    if (coreHarnessPath === void 0) { coreHarnessPath = ingestCoreHarnessPath(); }
    var port;
    if (!(port = portsConfig[packageName]))
        return;
    var packageUrl = replacePort(coreHarnessPath, port);
    return packageUrl;
};
var ingestOrSetPortsConfig = function () {
    // If an extension and ports have already been set by the core harness, ingest them
    var _a;
    if ((_a = window.cadmium) === null || _a === void 0 ? void 0 : _a.ports)
        return window.cadmium.ports;
    var config = createDevelopmentPortsConfig();
    // If running in node (under test), or in the production application, return the config
    if (typeof window === 'undefined' || !window.cadmium)
        return config;
    // Write to window cadmium API for extensions to consume
    window.cadmium.ports = config;
    return config;
};
var ingestCoreHarnessPath = function () {
    var _a, _b;
    if ((_a = window.cadmium) === null || _a === void 0 ? void 0 : _a.harnessPath)
        return window.cadmium.harnessPath;
    return (_b = "undefined") !== null && _b !== void 0 ? _b : '';
};
export { setLocalDevelopmentPath };
//# sourceMappingURL=setLocalDevelopmentPath.js.map